/**
 * Checks if the given url is valid
 * @param url - The url to check
 * @returns True if url is valid, false otherwise
 */
export function isUrl(url: string | URL): boolean {
  try {
    const parsedUrl = typeof url === "string" ? new URL(url) : url

    // Additional check for valid protocols if the URL is a string
    if (typeof url === "string" && !["http:", "https:"].includes(parsedUrl.protocol)) {
      return false
    }

    return true
  } catch {
    return false
  }
}
